var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DepartmentTripleCards',{attrs:{"directions":_vm.data.directions || {},"patient-needs":_vm.data.patientNeeds || {},"documents":_vm.data.documents || {}}})}
var staticRenderFns = []

export { render, staticRenderFns }